import { Box, Button, Group, Image, List, Modal, Stack, Text, ThemeIcon } from '@mantine/core'
import { observer } from 'mobx-react-lite'

import SWPiOSImage from '@/assets/images/SWP_iOS.png'
import { useBeforeYouStartPopup } from '@/hooks/useBeforeYouStartPopup'
import useCheckMobileScreen from '@/hooks/useCheckMobileScreen'

export interface BeforeYouStartPopupProps {
  /** Whether to show the popup - defaults to true */
  visible?: boolean
}

export const BeforeYouStartPopup = observer(function BeforeYouStartPopup(props: BeforeYouStartPopupProps) {
  const { visible = true } = props
  const { shouldShow, handleClose, handleGetStarted } = useBeforeYouStartPopup()
  const isMobile = useCheckMobileScreen()

  if (!visible || !shouldShow) {
    return null
  }

  return (
    <Modal.Root opened={shouldShow} onClose={handleClose} centered size="lg">
      <Modal.Overlay />
      <Modal.Content px="md">
        <Modal.Header>
          <Modal.Title style={{ fontSize: '1.5rem' }}>Before you Start</Modal.Title>
          <Modal.CloseButton />
        </Modal.Header>
        <Modal.Body>
          <Stack gap="lg">
            {/* Header section */}
            <Box>
              <Text mb="xs" size="sm" fw={500}>
                Download the Sidekick Platform Mobile App
              </Text>
              <Text size="xs" c="dimmed">
                On your mobile device, download the Sidekick Platform app by searching for &ldquo;Sidekick
                Platform&rdquo; in either the Apple App Store (iOS) or Google Play Store (Android).
              </Text>
            </Box>

            {/* App store listing mockup */}
            <Group gap="md" align="center">
              <Image src={SWPiOSImage} alt="Sidekick Platform App Icon" h={isMobile ? 100 : 150} radius="md" />
            </Group>

            {/* Instructions */}
            <Box>
              <Text size="sm" fw={500} mb="md">
                After installation is complete:
              </Text>
              <List spacing="sm" size="sm">
                <List.Item
                  icon={
                    <ThemeIcon color="indigo" size={24} radius="xl">
                      <Text size="xs" fw={600}>
                        1
                      </Text>
                    </ThemeIcon>
                  }>
                  Open the Sidekick Platform app.
                </List.Item>
                <List.Item
                  icon={
                    <ThemeIcon color="indigo" size={24} radius="xl">
                      <Text size="xs" fw={600}>
                        2
                      </Text>
                    </ThemeIcon>
                  }>
                  Log in using the same email and password you used for this content portal.
                </List.Item>
                <List.Item
                  icon={
                    <ThemeIcon color="indigo" size={24} radius="xl">
                      <Text size="xs" fw={600}>
                        3
                      </Text>
                    </ThemeIcon>
                  }>
                  Talk with your Personal Sidekick for assistance with the setup process.
                </List.Item>
              </List>
            </Box>

            {/* Button */}
            <Group justify="center" mt="md">
              <Button onClick={handleGetStarted} px="xl">
                OK
              </Button>
            </Group>
          </Stack>
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
  )
})
